import React, { useState, useEffect, useRef } from 'react';
import { useHistory, Redirect, Link, useLocation } from 'react-router-dom';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import styled from 'styled-components';
import { isTablet, useMobileOrientation } from 'react-device-detect';
import TurnstileWidget from 'Components/Shared/TurnstileWidget';

import PasswordInput from 'Components/UI/PasswordInput';

import { useUserStore } from 'Store/userStore';
import { postLogin as httpLogin } from 'Services/AuthService';

const FormWrapper = styled.div`
    color: #000;
    border: 1px solid #fff;
    // border: 1px solid #d0e6ff;
    background: #fff;
    border-radius: 15px;
    .cli_icon-login {
        color: #205fa6;
        font-size: 10rem;
    }
    .cli_img-login {
        width: 15rem;
    }
    .cli_login-header {
        h2,
        p {
            color: #205fa6;
        }
    }
    hr {
        background-color: rgb(150 206 0);
        height: 3px;
        margin-left: -15px;
        margin-right: -15px;
    }
    form {
        .text-label-login {
            color: #205fa6;
        }
    }
    a {
        color: #146ac6;
        text-decoration: none;
        background-color: transparent;
        text-decoreation: none;
    }
    button {
        background-color: #92bf19;
        border-color: #92bf19;
        :hover {
            background-color: rgb(150 206 0);
            border-color: rgb(150 206 0);
        }
    }
    .cli-copyrights {
        color: #205fa6;
        font-weight: 400;
        font-size: 14px;
        font-family: 'Helvetica Neue', 'Segoe UI', helvetica, verdana, sans-serif;
    }
    .cli-design-cr {
        color: #ffffff;
        background: #205fa6;
        border: 1px solid #205fa6;
        border-radius: 10px 10px 50px 50px;
    }
`;

const Login = () => {
    const history = useHistory();
    const { state } = useLocation();

    const user = useUserStore((state) => state.user);
    const setUser = useUserStore((state) => state.setUser);

    const [redirectTo, setRedirectTo] = useState('/apps');
    const [Error, setError] = useState(null);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [turnstileToken, setTurnstileToken] = useState(null);
    const turnstileRef = useRef();

    const { isLandscape } = useMobileOrientation();

    useEffect(() => {
        const REDIRECT_TO = state && state.referrer !== '/' ? `${encodeURIComponent(state.referrer)}` : '';
        setRedirectTo(`${decodeURIComponent(REDIRECT_TO)}`);
    }, []);

    const handleSumitForm = async (e) => {
        e.preventDefault();
        if (!turnstileToken) {
            setError('Veuillez compléter la vérification CAPTCHA');
            return;
        }
        postLogin(turnstileToken);
    };

    const postLogin = async (token) => {
        const credentials = {
            userName,
            password,
            turnstileToken: token,
        };
        try {
            const userConnectedData = await httpLogin(credentials);
            setUser(userConnectedData);
            if (userConnectedData.MustChangePassword === 'True') {
                localStorage.setItem('nextUrl', redirectTo);
                history.replace(`/profile/password`);
            } else {
                history.replace(redirectTo);
            }
        } catch (ex) {
            // Token is single-use — reset widget so user gets a fresh one
            setTurnstileToken(null);
            turnstileRef.current?.reset();
            const { response: { data: { message } = {} } = {} } = ex;
            setError(message || 'Error occured!');
        }
    };

    const loginForm = (
        <Form onSubmit={handleSumitForm}>
            <Form.Group controlId="formBasicUserName" className="text-left text-label-login">
                <Form.Label>Nom d&apos;utilisateur</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Nom d'utilisateur"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                />
            </Form.Group>

            <Form.Group controlId="formBasicPassword" className="text-left text-label-login">
                <Form.Label>Mot de passe</Form.Label>
                <PasswordInput
                    placeholder="Mot de passe"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    hasValidation={false}
                />
            </Form.Group>

            <div className="mb-3 d-flex justify-content-center">
                <TurnstileWidget
                    ref={turnstileRef}
                    siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => setTurnstileToken(token)}
                    onError={() => {
                        setTurnstileToken(null);
                        setError('Erreur CAPTCHA, veuillez réessayer');
                    }}
                    onExpire={() => setTurnstileToken(null)}
                    action="CLIAM_LOGIN"
                />
            </div>

            <Button className="w-100" variant="primary" type="submit">
                Se connecter
            </Button>
        </Form>
    );

    return user ? (
        <Redirect to="/" />
    ) : (
        <div className="h-100">
            <Row className="bg-login-content">
                {isTablet && isLandscape ? (
                    <Col lg={{ span: 8, offset: 2 }}>
                        <FormWrapper className="px-3 py-3 mx-3 my-3">
                            <Row>
                                <Col>
                                    <div className="text-center cli_login-header">
                                        <img
                                            src="/images/cliam_logo.svg"
                                            alt="cliam- logo"
                                            className="cli_img-login mb-3"
                                        />
                                        <h2>Se connecter à CLIAM</h2>
                                        <p>Chaabi Lil Iskane Identity and Access Management</p>
                                        {Error && <Alert variant="danger">{Error}</Alert>}
                                    </div>
                                </Col>
                                <Col className="align-self-center">{loginForm}</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr />
                                    <div className="mt-3 text-center">
                                        <Link to="/password/forget">Mot de passe oublié?</Link>
                                        <div className="mt-3 cli-copyrights cli-design-cr">
                                            CLI &#169; {new Date().getFullYear()}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </FormWrapper>
                    </Col>
                ) : (
                    <Col md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                        <FormWrapper className="px-3 py-3 mx-3 my-3">
                            <div className="text-center cli_login-header">
                                <img src="/images/cliam_logo.svg" alt="cliam- logo" className="cli_img-login mb-3" />
                                <h2>Se connecter à CLIAM</h2>
                                <p>Chaabi Lil Iskane Identity and Access Management</p>
                                {Error && <Alert variant="danger">{Error}</Alert>}
                            </div>
                            <hr />
                            {loginForm}
                            <div className="mt-3 text-center">
                                <Link to="/password/forget">Mot de passe oublié?</Link>
                                <div className="mt-3 cli-copyrights cli-design-cr">
                                    CLI &#169; {new Date().getFullYear()}
                                </div>
                            </div>
                        </FormWrapper>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default Login;
